import { memo, useCallback, useMemo } from 'react';
import styled from '@emotion/styled';
import { mediaMax, spacing } from 'presentations/views/styles';
import { DateTime, getDateTime } from 'infras/datetime';
import Select from 'presentations/views/components/atoms/Select';

export interface Props {
  timeZone: string;
  className?: string;
  name?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  date?: DateTime | null;
  onSelect?: (datetime: DateTime) => void;
}

const Component = memo((props: Props) => {
  const date = getDateTime(props.date);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let newValue = date;
      if (e.target.name === 'hour') {
        newValue = date.set({ hour: Number(e.target.value) });
      } else if (e.target.name === 'minute') {
        newValue = date.set({ minute: Number(e.target.value) });
      }
      props.onSelect && props.onSelect(newValue);
    },
    [props.onSelect, props.date],
  );

  const hourOptions = useMemo(() => {
    return new Array(24).fill(0).map((_, index) => ({
      value: index,
      text: `0${index}`.slice(-2),
    }));
  }, []);

  const minuteOptions = useMemo(() => {
    return new Array(60).fill(0).map((_, index) => ({
      value: index,
      text: `0${index}`.slice(-2),
    }));
  }, []);

  return (
    <Container>
      <StyledSelect
        name="hour"
        size="small"
        value={date.hour}
        variant="filled"
        onChange={onChange}
        options={hourOptions}
      />
      <div>:</div>
      <StyledContainer>
        <StyledSelect
          name="minute"
          size="small"
          value={date.minute}
          variant="filled"
          onChange={onChange}
          options={minuteOptions}
        />
      </StyledContainer>
    </Container>
  );
});
export default Component;

const Container = styled.div`
  display: flex;
  align-items: center;

  & .MuiFormControl-root {
    width: 40px;
    margin: 0;
  }
  & .MuiSelect-outlined.MuiSelect-outlined {
    background: none;
  }
  & .MuiFilledInput-input {
    padding-right: ${spacing(12)} !important;
    padding: ${spacing(8)} ${spacing(12)} ${spacing(8)} ${spacing(12)};
  }
  & .MuiSvgIcon-root {
    display: none;
  }
`;
const StyledContainer = styled.div`
  margin-right: ${spacing(4)};
  ${mediaMax.tablet} {
    margin-right: 0;
  }
`;
const StyledSelect = styled(Select)`
  appearance: none;
`;
